module.exports = __webpack_public_path__ + "static/media/inpecstion.33547782.svg";